import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, ArrowRight, AlertTriangle } from "lucide-react";
import api, { API } from "@/lib/api";
import { Section } from "@/components/common";
import { DISCLAIMER } from "@/pages/PowerStudy";
import SampleReportViewer from "@/components/SampleReportViewer";

const SampleDownload = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/power-study/sample").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  if (!info?.available) return null;
  return (
    <a href={`${API}/power-study/sample/download`} data-testid="sample-download-btn"
      className="inline-flex items-center gap-2 border border-white/15 hover:border-[#84CC16] text-white font-semibold px-5 py-3 rounded-full transition-colors">
      <Download size={16} /> Download full sample ({info.ext.toUpperCase()})
    </a>
  );
};

export default function PowerStudySample() {
  return (
    <Section className="py-14 sm:py-20 max-w-5xl">
      <p className="eyebrow mb-2">Sample report</p>
      <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl text-white">See what you get</h1>
      <p className="text-slate-300 mt-4 max-w-2xl text-sm sm:text-base">
        A complete sample of all three documents delivered with every DYOR Power Feasibility Study, built for a fictional site.
      </p>
      <div className="flex flex-wrap gap-3 mt-6">
        <Link to="/power-study#order" data-testid="sample-order-btn" className="inline-flex items-center gap-2 bg-[#84CC16] hover:bg-[#9ee325] text-[#0B0F17] font-bold px-6 py-3 rounded-full transition-colors">
          Order a Study <ArrowRight size={16} />
        </Link>
        <SampleDownload />
      </div>
      <div className="mt-10"><SampleReportViewer /></div>
      <div className="mt-6 rounded-xl border border-amber-500/30 bg-amber-500/10 px-5 py-4 flex gap-3" data-testid="sample-disclaimer">
        <AlertTriangle size={18} className="text-amber-400 shrink-0 mt-0.5" />
        <p className="text-amber-100 text-sm">{DISCLAIMER}</p>
      </div>
    </Section>
  );
}
